export default {
      id: "svg-icon-pagination-previous-usage",
      viewBox: "0 0 11.916 23.771",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-pagination-previous",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/pagination-previous.svg
// module id = oTWN
// module chunks = 4